(function(root){
  function integer(value,fallback){const number=Number(value);return Number.isFinite(number)?Math.trunc(number):fallback;}
  function state(variant){
    const min=Math.max(1,integer(variant.quantityMin,1));
    const step=Math.max(1,integer(variant.quantityIncrement,1));
    const stock=variant.inventoryTracked?Math.max(0,integer(variant.inventoryQuantity,0)):Infinity;
    const rule=variant.quantityMax==null?Infinity:Math.max(0,integer(variant.quantityMax,0));
    const inCart=Math.max(0,integer(variant.cartQuantity,0));
    const remaining=Math.max(0,Math.min(stock,rule)-inCart);
    const max=Number.isFinite(remaining)?(remaining<min?0:min+Math.floor((remaining-min)/step)*step):null;
    const inStock=Boolean(variant.available)&&stock>0;
    return {min,step,max,inStock,canAdd:inStock&&(max===null||max>=min)};
  }
  function clamp(value,limits){
    if(!limits.canAdd)return 0;
    const raw=Math.max(limits.min,integer(value,limits.min));
    const aligned=limits.min+Math.floor((raw-limits.min)/limits.step)*limits.step;
    return limits.max===null?aligned:Math.min(aligned,limits.max);
  }
  const api={state,clamp};
  if(typeof module!=="undefined"&&module.exports)module.exports=api;
  else root.CaravanPurchaseLimits=api;
})(typeof window!=="undefined"?window:this);
